import QuestionsList from "./components/questions/QuestionsList";
import SurveyDescription from "./components/SurveyDescription";
import SurveyFinalMessage from "./components/SurveyFinalMessage";
import SurveyTemplateOptions from "./components/SurveyTemplateOptions";

export const tabsOptions = (values, handleChange, setFieldValue, errors, surveyId, isLoading) => [{
  eventKey: 'questions',
  title: 'Preguntas',
  content: <QuestionsList surveyId={surveyId} />,
  disabled: isLoading || surveyId ? false : true
},{
  eventKey: 'description',
  title: 'Descripción',
  content: <SurveyDescription values={values} handleChange={handleChange} errors={errors} />,
  disabled: isLoading
},{
  eventKey: 'options',
  title: 'Opciones',
  content: <SurveyTemplateOptions values={values} handleChange={handleChange} setFieldValue={setFieldValue} errors={errors} />,
  disabled: isLoading
},{
  eventKey: 'finalMessage',
  title: 'Mensaje final',
  content: <SurveyFinalMessage values={values} handleChange={handleChange} errors={errors} />,
  disabled: isLoading
}];